import $ from './app/jquery-shim.js';
import Utils from './app/utils.js';
import Accordion from './app/accordion.js';
import Anchor from './app/anchor.js';
import FixedHeader from './app/fixedheader.js';
import HeightLine from './app/heightline.js';
import ResponsiveTable from './app/responsive-table.js';
import Slidebar from './app/slidebar.js';
import Tab from './app/tab.js';
import CurrentNav from './app/current-nav.js';
import ScrollReveal from "scrollreveal";
import buildFormat from './app/format.js';
import OwlCarousel from 'owl.carousel';
import fontAwesome from "font-awesome/scss/font-awesome.scss"
import OwlCss from "owl.carousel/dist/assets/owl.carousel.css"
import OwlThemeCss from "owl.carousel/dist/assets/owl.theme.default.css"
// import PickerJs           from "pickadate/lib/compressed/picker.js"
// import PickerDateJs       from "pickadate/lib/compressed/picker.date.js"
// import PickerTimeJs       from "pickadate/lib/compressed/picker.time.js"
// import PickerDateJsJa       from "pickadate/lib/compressed/translations/ja_JP.js"
// import PickerThemeCss     from "pickadate/lib/compressed/themes/default.css"
// import PickerDateThemeCss from "pickadate/lib/compressed/themes/default.date.css"
// import PickerTimeThemeCss from "pickadate/lib/compressed/themes/default.time.css"
import lightgallery from 'lightgallery';
import lightgallerycss from "lightgallery/dist/css/lightgallery.css"
import lightgalleryvideo from 'lg-video';


class App {
  constructor() {
    this.Utils = new Utils();
    this.Accordion = new Accordion();
    this.Anchor = new Anchor();
    this.FixedHeader = new FixedHeader();
    this.HeightLine = new HeightLine();
    this.ResponsiveTable = new ResponsiveTable();
    this.Slidebar = new Slidebar();
    this.CurrentNav = new CurrentNav();
    this.Tab = new Tab();


    function slider() {

      $(".c-mainvisual-slider .owl-carousel").owlCarousel({
        items: 1,
        dots: true,
        loop: true,
        nav: false,
        autoplay: true,
        //autoplaySpeed: 5600,
        animateIn: 'fadeIn',
        animateOut: 'fadeOut',
        autoWidth: false,
        autoHeight: false,
        mouseDrag: false,
        touchDrag: false,
        pullDrag: false
      });

      $(".c-banner-slider .owl-carousel").owlCarousel({
        items: 3,
        dots: true,
        loop: true,
        nav: true,
        autoplay: true,
        navText: "",
        // //autoplaySpeed: 5600,
        // animateIn: 'fadeIn',
        // animateOut: 'fadeOut',
        autoWidth: false,
        autoHeight: false,
        margin: 10,

        responsive: {
          0: {
            items: 2,
            center: true,
          },
          765: {
            items: 3
          }
        }

      });
      $(".c-photo-slider .owl-carousel").owlCarousel({
        items: 6,
        dots: true,
        loop: true,
        nav: true,
        autoplay: true,
        navText: "",
        // //autoplaySpeed: 5600,
        // animateIn: 'fadeIn',
        // animateOut: 'fadeOut',
        autoWidth: false,
        autoHeight: false,
        margin: 10,

        responsive: {
          0: {
            items: 2,
            center: true,
          },
          765: {
            items: 4
          },
          1200: {
            items: 4
          }
        }

      });

      // $('.c-image-slider__main').imagesLoaded(function () {
      //
      // });


    }

    function scrollReveal() {

      // スクロールリーバル
      window.sr = new ScrollReveal({duration: 1200, mobile: true});

      // scroll add class
      // https://github.com/scrollreveal/scrollreveal/issues/337#issuecomment-309657013
      sr.watch = function (target, onEnter, onExit) {
        onExit = onExit || function () {
        }
        if (typeof onEnter === 'function' && typeof onExit === 'function') {
          var noEffect = {
            delay: 0,
            distance: 0,
            duration: 0,
            scale: 1,
            opacity: null,
            rotate: {x: 0, y: 0, z: 0,},

            reset: true,
            beforeReset: onExit,
            beforeReveal: onEnter,
          }
          this.reveal(target, noEffect)
        } else {
          throw new Error('Watch received invalid arguments.')
        }
      };
      sr.watch('.js-reveal-blur,.js-reveal-blur-medium,.js-reveal-blur-long',
        function onEnter(el) {
          el.classList.add('js-reveal-blur-active')
        },
        function onExit(el) {
          // el.classList.remove('js-reveal-blur-active')
        }
      )

      sr.reveal(".js-reveal-fade,.c-instagram__item", {scale: 1, duration: 1200, distance: '0', delay: 0}, 100);
      sr.reveal(".js-reveal-fade-medium", {scale: 1, duration: 1200, distance: '0', delay: 300}, 100);
      sr.reveal(".js-reveal-fade-long", {scale: 1, duration: 1200, distance: '0', delay: 600}, 100);
      sr.reveal(".js-reveal-slidedown", {
        scale: 1,
        duration: 1200,
        distance: '20px',
        origin: 'top',
        delay: 300
      }, 100);
      sr.reveal(".js-reveal-slidedown-short", {
        scale: 1,
        duration: 1200,
        distance: '20px',
        origin: 'top',
        delay: 0
      }, 100);
      sr.reveal(".js-reveal-slidedown-medium", {
        scale: 1,
        duration: 1200,
        distance: '20px',
        origin: 'top',
        delay: 300
      }, 100);
      sr.reveal(".js-reveal-slidedown-long", {
        scale: 1,
        duration: 1200,
        distance: '20px',
        origin: 'top',
        delay: 600
      }, 100);
      sr.reveal(".js-reveal-slideup-short", {
        scale: 1,
        duration: 1200,
        distance: '20px',
        origin: 'bottom',
        delay: 0
      }, 100);
      sr.reveal(".js-reveal-slideup-medium", {
        scale: 1,
        duration: 1200,
        distance: '20px',
        origin: 'bottom',
        delay: 300
      }, 100);
      sr.reveal(".js-reveal-slideup-long", {
        scale: 1,
        duration: 1200,
        distance: '20px',
        origin: 'bottom',
        delay: 600
      }, 100);
      sr.reveal(".js-reveal-slideleft", {
        scale: 1,
        duration: 1200,
        distance: '20px',
        origin: 'right',
        delay: 600
      }, 100);

      sr.reveal(".js-reveal-slideright", {
        scale: 1,
        duration: 1200,
        distance: '20px',
        origin: 'left',
        delay: 600
      }, 100);


      function domEach(items, callback) {
        if (typeof items === "string") {
          var items = $(items);
        }

        for (var i = 0; i < items.length; i++) {
          var item = items[i];
          // callback = callback.bind(item)
          callback(i, item);
        }
      }

      var blocks01 = $(".js-reveal-chain");
      domEach(blocks01, function (key, item) {
        sr.reveal(item, {scale: 1, delay: 100, duration: 400, distance: '10px'}, 100);
        sr.reveal(item.children[1], {delay: 200, scale: 1, duration: 400, distance: '10px', easing: 'ease'}, 100);
        sr.reveal(item.children[2], {delay: 300, scale: 1, duration: 400, distance: '10px', easing: 'ease'}, 100);
        sr.reveal(item.children[3], {delay: 400, scale: 1, duration: 400, distance: '10px', easing: 'ease'}, 100);
        sr.reveal(item.children[4], {delay: 500, scale: 1, duration: 400, distance: '10px', easing: 'ease'}, 10);
        sr.reveal(item.children[5], {delay: 600, scale: 1, duration: 400, distance: '10px', easing: 'ease'}, 100);
        sr.reveal(item.children[6], {delay: 700, scale: 1, duration: 400, distance: '10px', easing: 'ease'}, 100);
        sr.reveal(item.children[7], {delay: 800, scale: 1, duration: 400, distance: '10px', easing: 'ease'}, 100);
        sr.reveal(item.children[8], {delay: 900, scale: 1, duration: 400, distance: '10px', easing: 'ease'}, 100);
        sr.reveal(item.children[9], {delay: 1000, scale: 1, duration: 400, distance: '10px', easing: 'ease'}, 100);
        sr.reveal(item.children[10], {delay: 1100, scale: 1, duration: 400, distance: '10px', easing: 'ease'}, 100);
        sr.reveal(item.children[11], {delay: 1200, scale: 1, duration: 400, distance: '10px', easing: 'ease'}, 100);
        sr.reveal(item.children[12], {delay: 1300, scale: 1, duration: 400, distance: '10px', easing: 'ease'}, 100);
        sr.reveal(item.children[13], {delay: 1400, scale: 1, duration: 400, distance: '10px', easing: 'ease'}, 100);
        sr.reveal(item.children[14], {delay: 1500, scale: 1, duration: 400, distance: '10px', easing: 'ease'}, 100);
        sr.reveal(item.children[15], {delay: 1600, scale: 1, duration: 400, distance: '10px', easing: 'ease'}, 100);
      });


    }

    function tableRowSelector() {
      if ($(".js-table-row-selector").length <= 0) {
        return;
      }

      function tableRowSelect($elm) {
        var target_tag = $($elm).attr("data-target");
        var target_class = $($elm).val();
        if (target_class == "") {
          $(target_tag).show();
          return true;
        }
        $(target_tag).hide();
        $(target_tag + target_class).show();
      }

      $(".js-table-row-selector").click(function () {
        if ($(this).prop('checked')) {
          tableRowSelect(this);
        }
      });
      if ($(".js-table-row-selector:checked").length > 0) {
        tableRowSelect($(".js-table-row-selector:checked"));
      }
    }


    function scrollAdaptive() {

      $(window).on('scroll', function (event) {
        var header_height = $(".l-header").height() + 100;
        var scroll_top = $(window).scrollTop();

        if (scroll_top >= header_height) {
          $("body").addClass("is-scrolling");
        } else {
          $("body").removeClass("is-scrolling");
        }
      });
    }

    function lightGallery() {
      $(".js-photo-gallery").lightGallery({
        selector: 'a[href$=".jpg"], a[href$=".jpeg"], a[href$=".png"], a[href$=".gif"]',
        controls: true,
        download: false,
        counter: false,
        getCaptionFromTitleOrAlt: false,
        enableSwipe: true,
        enableDrag: true,
      });
      $(".js-movie-popup").lightGallery({
        controls: true,
        download: false,
        counter: false,
        getCaptionFromTitleOrAlt: false,
        enableSwipe: true,
        enableDrag: true,
        thumbnail: true,
        selector: ".c-movie-thumbnail"
      });
    }


    $(function () {
      slider();
      scrollReveal();
      scrollAdaptive();
      tableRowSelector();
      lightGallery();
    });
  }
}

window
  .GApp = new App();
